export default {
  0: 'Normal',
  1: 'Assessor'
}
